/** Services / On Demand chrome (matches customer `UcTokens.purple`). */
export const ON_DEMAND_CHROME = '#6D28D9';

/** Legacy accents remapped so existing tenants get the current chrome color. */
const LEGACY_ON_DEMAND_ACCENTS = new Set([
  '#0891b2',
  '#0891B2',
  '#0e7490',
  '#0E7490',
  '#6B4EFF',
  '#6b4eff',
]);

/**
 * Accent for On Demand hub header / tab rail only.
 * Remaps seeded teal / previous UC purple defaults; preserves custom theme colors.
 */
export function resolveOnDemandChromeAccent(themeColor?: string | null): string {
  const raw = (themeColor || '').trim();
  if (!raw || LEGACY_ON_DEMAND_ACCENTS.has(raw)) return ON_DEMAND_CHROME;
  return raw;
}
